

export default {
  name: "areaStyle",
  nickname: "分隔区域样式",
  desc: "区域填充样式。",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "填充的颜色。",
      value: "#000",
      defaultValue: "#000",
      type: "pureValue",
      eType: "color",
    },
    origin: {
      name: "origin",
      nickname: "中心点",
      desc: "图形区域的起始位置。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
  },
}
